<template>
    <div class="progress" style="height: 20px;">
        <div class="progress-bar bg-info" :style="{ width: currentProgress + '%', height: '20px' }" role="progressbar"
            :aria-valuenow="currentProgress" aria-valuemin="0" aria-valuemax="100">
            <div class="circle"></div> <!-- Círculo dentro da barra de progresso -->
            <input type="text" class="form-control" style="background-color: transparent;color: white"
                :value="currentProgress.toFixed(1) + '%'" readonly>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            currentProgress: 0
        };
    },
    mounted() {
        this.animateProgress();
    },
    methods: {
        animateProgress() {
            const interval = setInterval(() => {
                if (this.currentProgress >= this.value) {
                    this.currentProgress = this.value;
                    clearInterval(interval);
                } else {
                    this.currentProgress = Math.min(this.currentProgress + 5, this.value);
                }
            }, 20);
        }
    }
};
</script>

<style scoped>
.progress {
    overflow: visible;
    position: relative;
    display: flex;
    align-items: center;
}

.progress-bar {
    height: 20px;
    position: relative;
    transition: width 2s ease;
    border-radius: 0px 20px 20px 0px;
}

.circle {
    position: absolute;
    width: 14px;
    height: 14px;
    background-color: #fff;
    border-radius: 50%;
    right: 0px;
    /* Ajusta a posição do círculo para dentro da área colorida */
    top: 50%;
    transform: translateY(-50%);
}

.progress-value {
    position: absolute;
    top: -25px;
    /* Fica acima da barra de progresso */
    font-weight: bold;
    color: white;
    background-color: #264c86;
    padding: 5px 10px;
    border-radius: 5px;
    transition: left 0.3s ease;
    /* Faz a transição do valor conforme a barra cresce */
    z-index: 10;
    /* Garante que o valor fique acima da barra de progresso */
}
</style>